<template>
	<main class="flex-container not-found">
		<div class="not-found-container">
			<div class="svg-container">
				<CarBrokenSVG />
			</div>
			<h1 v-if="errorTitle">{{ errorTitle }}</h1>
			<h1 v-else>Ooops... Page Not Found</h1>
			<p
				v-if="errorMessage"
				class="not-found-subtext"
			>
				An error has occurred {{ errorMessage }}.
			</p>
			<p
				v-else
				class="not-found-subtext"
			>
				Sorry, you've hit a bump in the road! Looks like the page you were searching for has taken a detour. Please click the back button on your browser to get
				back on track.
			</p>
		</div>
	</main>
</template>

<script setup>
	import CarBrokenSVG from '@/components/customerPortal/customComponents/CarBrokenSVG.vue';
	const { errorMessage } = defineProps({
		errorTitle: {
			type: String,
			default: '',
		},
		errorMessage: {
			type: String,
			default: '',
		},
	});
</script>

<style scoped>
	.not-found {
		padding: 3%;
	}
	.not-found-container {
		text-align: center;
		align-items: center;
		justify-content: center;
		display: flex;
		justify-content: center;
		flex-direction: column;
		width: 100%;
		height: 91vh;
		background-color: #fcfdfd;
		border-radius: 9px;
		padding: 25px;
		padding-right: 30px;
		box-shadow:
			0 20px 25px -5px rgba(0, 0, 0, 0.1),
			0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
		box-shadow:
			0 0 #0000,
			0 0 #0000,
			0 0 #0000,
			0 0 #0000,
			0 0 #0000 !important;
	}

	.svg-container {
		width: 20%;
	}

	.not-found-subtext {
		width: 68%;
		margin-top: 5px;
		margin-bottom: 15px;
		color: black;
		font-weight: 300;
		font-size: 14px;
		text-align: center;
	}

	.button-wrapper {
		display: flex;
		justify-content: center;
	}
</style>
